export default function Pill({ children, className, ...props }) {
  return (
    <div
      className={className}
      sx={{
        display: "flex",
        padding: "8px 16px",
        justifyContent: "center",
        alignItems: "center",
        gap: "10px",
        fontSize: 0,
        borderRadius: "32px",
        backgroundColor: "#3A3D4F",
        color: "#E5E5E5",
        border: 0,
        cursor: "pointer",
      }}
      {...props}
    >
      {children}
    </div>
  )
}
